// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import { mediaMax } from 'frontend_core/dist/styles/media'

const TitleContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid ${Colors.grayE};
  background-color: ${Colors.white};

  &::after {
    clear: both;
    content: '';
    display: block;
  }
`
const TitleTabContent = styled.a`
  display: inline-block;
  float: left;
  width: 120px;
  padding: ${spacing.medium}px;
  color: ${Colors.black};
  font-size: ${fontSize.small_3}px;
  text-align: center;
  border-bottom: 2px solid transparent;
  cursor: pointer;

  &:hover {
    border-bottom: 2px solid ${Colors.blue};
  }
  ${mediaMax.phone`
    width: 50%;
    padding: ${spacing.medium}px;
  `} ${({ current }) =>
    current &&
    css`
      font-weight: bold;
      border-bottom: 2px solid ${Colors.blue};
    `};
`

type PropTypes = {
  tabList: Array<{
    current: boolean,
    label: string,
    href?: string,
    onClick?: (e: Event) => any,
  }>,
}

export default function Tab(props: PropTypes) {
  return (
    <TitleContainer>
      {props.tabList.map((item, index) => (
        <TitleTabContent
          key={`tablist_item_${index}`}
          current={item.current}
          href={item.href}
          onClick={item.onClick}
        >
          {item.label}
        </TitleTabContent>
      ))}
    </TitleContainer>
  )
}



// WEBPACK FOOTER //
// ./src/components/atoms/Tab/index.jsx